import React from "react";
import { CImage } from "@coreui/react";
import fallbackAvatar from "@/assets/images/avatars/DefaultImg.png";

/** Round user photo with the default avatar as a fallback for missing or broken images. */
const WeAllTeamAvatar = ({ src, size = 36, alt = "" }) => (
  <CImage
    src={src || fallbackAvatar}
    alt={alt}
    width={size}
    height={size}
    className="weall-team-avatar"
    style={{
      width: size,
      height: size,
      objectFit: "cover",
      borderRadius: "50%",
    }}
    onError={(e) => {
      e.target.onerror = null;
      e.target.src = fallbackAvatar;
    }}
  />
);

export default WeAllTeamAvatar;
